export default "__VITE_ASSET__DphSl0OM__"